<template>
  <div class="card-model-print">
    <v-card elevation="2" color="white" style="overflow: hidden">
      <v-layout
        justify-center
        align-center
        column
        style="position: absolute; width: 100%; height: 100%"
      >
        <v-layout justify-center align-center column>
          <v-icon size="60">mdi-smart-card-outline</v-icon>
          <div class="d-flex align-center justify-center flex-column pb-8">
            {{ $i18n.t("exportando_imagem") }}
            <v-progress-circular
              indeterminate
              width="2"
              size="18"
              color="blue"
              class="mr-2 mt-1"
            />
          </div>
        </v-layout>
      </v-layout>
      <v-card-text
        style="position: relative; height: 60vh; min-height: 60vh; width: 323px"
      >
        <v-layout align-center justify-center style="width: 323px">
          <v-card
            id="print-card"
            style="
              padding: 8px;
              transform: scale(0.96);
              border: 1px solid #0003;
              position: relative;
              z-index: -999;
              width: 323px;
              height: 204px;
            "
          >
            <v-card-text style="padding: 0">
              <v-card-subtitle style="padding: 0">
                <v-layout justify-space-between align-center>
                  <div>
                    <img
                      :src="cliente.imgLogo || $store.state.imgLogoDefault"
                      width="50"
                      alt=""
                    />
                  </div>
                  <div
                    class="font-weight-bold font-italic"
                    style="font-size: 11px"
                  >
                    Life Card
                  </div>
                </v-layout>
              </v-card-subtitle>
              <v-row style="padding: 1px 0 0; margin: 0">
                <v-col style="padding: 0; margin: 0">
                  <v-row style="padding: 0; margin: 0">
                    <v-col cols="12" style="padding: 0; margin: 0">
                      <v-chip
                        small
                        color="transparent"
                        style="
                          padding: 0;
                          margin: 0;
                          width: 100%;
                          border-radius: 0;
                        "
                      >
                        <v-layout column style="padding: 0 0 3px 0; margin: 0">
                          <v-layout align-center style="padding: 0; margin: 0">
                            <div style="font-size: 8px">{{ $t("Nome") }}</div>
                          </v-layout>
                          <v-layout
                            style="
                              padding: 0 0 3px;
                              margin: 0;
                              font-size: 11px;
                              line-height: 0.6;
                            "
                            class="font-weight-bold"
                          >
                            {{ getData({ field: "nome", type: "string" }) }}
                          </v-layout>
                        </v-layout>
                      </v-chip>
                      <v-divider
                        style="
                          padding: 0;
                          margin: 0;
                          position: relative;
                          top: 7px;
                        "
                        class="red lighten-2"
                      ></v-divider>
                    </v-col>
                    <v-col style="padding-left: 0; padding-right: 0" cols="9">
                      <v-row style="padding: 0; margin: 0">
                        <div
                          style="padding: 0; margin: 0"
                          class="d-flex flex-row flex-wrap justify-start"
                        >
                          <v-layout
                            style="padding: 0; margin: 0 0 10px 0"
                            align-center
                            justify-start
                            v-for="(item, i) in dataCard"
                            :key="i + 1"
                            class="flex-grow-0"
                          >
                            <v-chip
                              style="padding: 0 7px; margin: 0"
                              v-if="item.show"
                              small
                              class="overflow-visible"
                              color="transparent"
                            >
                              <v-layout column>
                                <v-layout align-center>
                                  <div style="font-size: 8px">
                                    {{ $i18n.t(dataCard[i].text) }}
                                  </div>
                                </v-layout>
                                <v-layout
                                  style="font-size: 11px; line-height: 0.6"
                                >
                                  <div
                                    :class="
                                      $vuetify.breakpoint.md
                                        ? 'text-wrap'
                                        : 'text-no-wrap'
                                    "
                                  >
                                    {{ getData(item) }}
                                  </div>
                                </v-layout>
                              </v-layout>
                            </v-chip>
                          </v-layout>
                        </div>
                      </v-row>
                    </v-col>
                    <v-col style="padding-left: 0; padding-right: 0" cols="3">
                      <v-row class="fill-height" style="padding: 0; margin: 0">
                        <v-col
                          class="fill-height"
                          style="padding: 0; margin: 0"
                        >
                          <v-layout
                            class="justify-center justify-md-end"
                            fill-height
                            align-center
                          >
                            <div>
                              <img
                                v-if="qrCodeImage"
                                alt=""
                                width="90"
                                :src="`data:image/png;base64, ${qrCodeImage}`"
                              />
                            </div>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["dataCard", "getData", "cliente", "qrCodeImageStatus", "qrCodeImage"],
};
</script>

<style lang="scss"></style>
